export default __webpack_public_path__ + "static/media/santa_green.ea3d2799.svg";